import type { GraphOptions } from "owp.graph-react";

export function getBorder(): GraphOptions["border"] {
    return {
        width: "1px",
    };
}
